import React, { useState, useEffect } from 'react';
import { PlusIcon, TrashIcon, PencilIcon } from '@heroicons/react/24/outline';
import api from '../services/api';
import axios from 'axios'; // TODO: rimuovere, usare api

const GestioneFontiProvenienza = () => {
  // Stati per le fonti
  const [fonti, setFonti] = useState([]);
  const [dettagliProvenienza, setDettagliProvenienza] = useState([]);
  const [selectedFonte, setSelectedFonte] = useState(null);
  const [loading, setLoading] = useState(false);
  
  // Stati per i modali
  const [showAddFonteModal, setShowAddFonteModal] = useState(false);
  const [showEditFonteModal, setShowEditFonteModal] = useState(false);
  const [showAddDettaglioModal, setShowAddDettaglioModal] = useState(false);
  const [showEditDettaglioModal, setShowEditDettaglioModal] = useState(false);
  
  // Form data
  const [fonteData, setFonteData] = useState({ descrizione: '' });
  const [dettaglioData, setDettaglioData] = useState({ descrizione: '', idFonte: '' });
  const [selectedDettaglio, setSelectedDettaglio] = useState(null);
  
  // Errori e messaggi
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  
  // Carica le fonti all'inizializzazione
  useEffect(() => {
    fetchFonti();
  }, []);
  
  // Carica i dettagli quando viene selezionata una fonte
  useEffect(() => {
    if (selectedFonte) {
      fetchDettagli(selectedFonte.id);
    } else {
      setDettagliProvenienza([]);
    }
  }, [selectedFonte]);
  
  // All'inizio del componente, aggiungi questo useEffect per il debugging
  useEffect(() => {
    console.log('Fonte selezionata:', selectedFonte);
  }, [selectedFonte]);
  
  // Funzione per recuperare tutte le fonti
  const fetchFonti = async () => {
    setLoading(true);
    try {
      console.log('Fetching fonti...');
      const response = await api.get('/lead/fonti');
      console.log('Fonti ricevute:', response.data);
      setFonti(response.data.data || []);
      setLoading(false);
    } catch (error) {
      console.error('Errore nel caricamento delle fonti:', error);
      setErrorMessage(`Impossibile caricare le fonti: ${error.response?.data?.error || error.message}`);
      setLoading(false);
    }
  };
  
  // Funzione per recuperare i dettagli di una fonte
  const fetchDettagli = async (fonteId) => {
    if (!fonteId) {
      console.log('Nessun ID fonte fornito, impossibile recuperare i dettagli');
      setDettagliProvenienza([]);
      return;
    }
    
    setLoading(true);
    try {
      console.log(`Fetching dettagli per fonte ID: ${fonteId}`);
      const response = await api.get(`/lead/dettagli-provenienza/${fonteId}`);
      console.log('Dettagli ricevuti:', response.data);
      
      // Verifica se i dati sono validi - ora accede correttamente a response.data.data
      const dettagli = response.data.data || [];
      if (Array.isArray(dettagli)) {
        setDettagliProvenienza(dettagli);
      } else {
        console.warn('Formato risposta non valido per i dettagli:', response.data);
        setDettagliProvenienza([]);
      }
    } catch (error) {
      console.error('Errore nel caricamento dei dettagli:', error);
      setErrorMessage(`Impossibile caricare i dettagli: ${error.response?.data?.error || error.response?.data?.details || error.message}`);
      setDettagliProvenienza([]);
    } finally {
      setLoading(false);
    }
  };
  
  // Funzione per aggiungere una nuova fonte
  const addFonte = async () => {
    if (!fonteData.descrizione.trim()) {
      setErrorMessage('Il nome della fonte è obbligatorio');
      return;
    }
    
    setLoading(true);
    try {
      console.log('Invio dati al server:', fonteData);
      const response = await api.post('/lead/fonti', fonteData);
      console.log('Risposta dal server:', response.data);
      setFonti([...fonti, response.data]);
      setShowAddFonteModal(false);
      setFonteData({ descrizione: '' });
      setSuccessMessage('Fonte aggiunta con successo');
      setTimeout(() => setSuccessMessage(''), 3000);
      setLoading(false);
    } catch (error) {
      console.error('Errore nella creazione della fonte:', error);
      setErrorMessage(`Impossibile creare la fonte: ${error.response?.data?.error || error.message}`);
      setLoading(false);
    }
  };
  
  // Funzione per modificare una fonte esistente
  const updateFonte = async () => {
    if (!fonteData.descrizione.trim()) {
      setErrorMessage('Il nome della fonte è obbligatorio');
      return;
    }
    
    setLoading(true);
    try {
      const response = await api.put(`/lead/fonti/${fonteData.id}`, fonteData);
      setFonti(fonti.map(f => f.id === fonteData.id ? response.data : f));
      
      // Aggiorna la fonte selezionata se è quella modificata
      if (selectedFonte && selectedFonte.id === fonteData.id) {
        setSelectedFonte(response.data);
      }
      
      setShowEditFonteModal(false);
      setFonteData({ descrizione: '' });
      setSuccessMessage('Fonte aggiornata con successo');
      setTimeout(() => setSuccessMessage(''), 3000);
      setLoading(false);
    } catch (error) {
      console.error('Errore nell\'aggiornamento della fonte:', error);
      setErrorMessage('Impossibile aggiornare la fonte. Riprova più tardi.');
      setLoading(false);
    }
  };
  
  // Funzione per eliminare una fonte
  const deleteFonte = async (fonteId) => {
    if (!window.confirm('Sei sicuro di voler eliminare questa fonte? Questa azione non può essere annullata.')) {
      return;
    }
    
    setLoading(true);
    try {
      await api.delete(`/lead/fonti/${fonteId}`);
      setFonti(fonti.filter(f => f.id !== fonteId));
      
      // Se la fonte eliminata era selezionata, deselezionala
      if (selectedFonte && selectedFonte.id === fonteId) {
        setSelectedFonte(null);
      }
      
      setSuccessMessage('Fonte eliminata con successo');
      setTimeout(() => setSuccessMessage(''), 3000);
      setLoading(false);
    } catch (error) {
      console.error('Errore nell\'eliminazione della fonte:', error);
      setErrorMessage('Impossibile eliminare la fonte. Riprova più tardi.');
      setLoading(false);
    }
  };
  
  // Funzione per aggiungere un nuovo dettaglio
  const addDettaglio = async () => {
    if (!dettaglioData.descrizione.trim()) {
      setErrorMessage('Il nome del dettaglio è obbligatorio');
      return;
    }
    
    if (!selectedFonte) {
      setErrorMessage('Seleziona prima una fonte');
      return;
    }
    
    // Verifica se la descrizione supera i 100 caratteri
    if (dettaglioData.descrizione.length > 100) {
      setErrorMessage('La descrizione non può superare i 100 caratteri');
      return;
    }
    
    setLoading(true);
    try {
      // Creazione payload corretto usando il nome campo richiesto dal backend
      const payload = {
        descrizione: dettaglioData.descrizione,
        fonteId: selectedFonte.id  // Il controller si aspetta fonteId
      };
      
      console.log('Invio dati dettaglio al server:', payload);
      const response = await api.post('/lead/dettagli-provenienza', payload);
      console.log('Risposta dal server (dettaglio):', response.data);
      
      // Aggiorna la lista dei dettagli
      setDettagliProvenienza([...dettagliProvenienza, response.data]);
      setShowAddDettaglioModal(false);
      setDettaglioData({ descrizione: '', idFonte: '' });
      setSuccessMessage('Dettaglio aggiunto con successo');
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (error) {
      console.error('Errore nella creazione del dettaglio:', error);
      setErrorMessage(`Impossibile creare il dettaglio: ${error.response?.data?.error || error.response?.data?.details || error.message}`);
    } finally {
      setLoading(false);
    }
  };
  
  // Funzione per modificare un dettaglio esistente
  const updateDettaglio = async () => {
    if (!dettaglioData.descrizione.trim()) {
      setErrorMessage('Il nome del dettaglio è obbligatorio');
      return;
    }
    
    // Verifica se la descrizione supera i 100 caratteri
    if (dettaglioData.descrizione.length > 100) {
      setErrorMessage('La descrizione non può superare i 100 caratteri');
      return;
    }
    
    setLoading(true);
    try {
      console.log('Aggiornamento dettaglio:', dettaglioData);
      const response = await api.put(`/lead/dettagli-provenienza/${dettaglioData.id}`, {
        descrizione: dettaglioData.descrizione,
        fonteId: selectedFonte.id  // Il controller si aspetta fonteId
      });
      console.log('Risposta aggiornamento dettaglio:', response.data);
      
      // Aggiorna l'elemento nella lista
      setDettagliProvenienza(dettagliProvenienza.map(d => 
        d.id === dettaglioData.id ? response.data : d
      ));
      
      setShowEditDettaglioModal(false);
      setDettaglioData({ descrizione: '', idFonte: '' });
      setSuccessMessage('Dettaglio aggiornato con successo');
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (error) {
      console.error('Errore nell\'aggiornamento del dettaglio:', error);
      setErrorMessage(`Impossibile aggiornare il dettaglio: ${error.response?.data?.error || error.response?.data?.details || error.message}`);
    } finally {
      setLoading(false);
    }
  };
  
  // Funzione per eliminare un dettaglio
  const deleteDettaglio = async (dettaglioId) => {
    if (!window.confirm('Sei sicuro di voler eliminare questo dettaglio? Questa azione non può essere annullata.')) {
      return;
    }
    
    setLoading(true);
    try {
      await api.delete(`/lead/dettagli-provenienza/${dettaglioId}`);
      setDettagliProvenienza(dettagliProvenienza.filter(d => d.id !== dettaglioId));
      setSuccessMessage('Dettaglio eliminato con successo');
      setTimeout(() => setSuccessMessage(''), 3000);
      setLoading(false);
    } catch (error) {
      console.error('Errore nell\'eliminazione del dettaglio:', error);
      setErrorMessage('Impossibile eliminare il dettaglio. Riprova più tardi.');
      setLoading(false);
    }
  };
  
  return (
    <div className="p-6 max-w-[1800px] mx-auto">
      <h1 className="text-2xl font-bold mb-6">Gestione Fonti e Dettagli Provenienza</h1>
      
      {/* Messaggi di successo ed errore */}
      {successMessage && (
        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">
          {successMessage}
        </div>
      )}
      
      {errorMessage && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
          {errorMessage}
          <span 
            className="float-right cursor-pointer" 
            onClick={() => setErrorMessage('')}
          >
            &times;
          </span>
        </div>
      )}
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Sezione Fonti */}
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-semibold">Fonti</h2>
            <button
              className="flex items-center text-white bg-blue-600 px-3 py-2 rounded-md hover:bg-blue-700"
              onClick={() => {
                setFonteData({ descrizione: '' });
                setShowAddFonteModal(true);
              }}
            >
              <PlusIcon className="h-4 w-4 mr-1" />
              Aggiungi Fonte
            </button>
          </div>
          
          {loading && fonti.length === 0 ? (
            <div className="text-center py-4">Caricamento...</div>
          ) : fonti.length === 0 ? (
            <div className="text-center py-4 text-gray-500">Nessuna fonte presente</div>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Descrizione</th>
                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Azioni</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {fonti.map((fonte) => (
                    <tr 
                      key={fonte.id}
                      className={`cursor-pointer hover:bg-gray-50 ${selectedFonte && selectedFonte.id === fonte.id ? 'bg-blue-50' : ''}`}
                      onClick={() => {
                        console.log('Selezionando fonte:', fonte);
                        setSelectedFonte(fonte);
                      }}
                    >
                      <td className="px-6 py-4 whitespace-nowrap">
                        {fonte.descrizione}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                        <button
                          className="text-indigo-600 hover:text-indigo-900 mr-3"
                          onClick={(e) => {
                            e.stopPropagation();
                            setFonteData(fonte);
                            setShowEditFonteModal(true);
                          }}
                        >
                          <PencilIcon className="h-5 w-5" />
                        </button>
                        <button
                          className="text-red-600 hover:text-red-900"
                          onClick={(e) => {
                            e.stopPropagation();
                            deleteFonte(fonte.id);
                          }}
                        >
                          <TrashIcon className="h-5 w-5" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
        
        {/* Sezione Dettagli */}
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-semibold">
              {selectedFonte 
                ? `Dettagli per: ${selectedFonte.descrizione}` 
                : 'Dettagli Provenienza'}
            </h2>
            
            {selectedFonte ? (
              <button
                type="button"
                className="bg-blue-600 text-white font-bold px-4 py-2 rounded-md flex items-center hover:bg-blue-700 shadow-md"
                onClick={() => {
                  console.log('Cliccato su aggiungi dettaglio - fonte selezionata:', selectedFonte.id);
                  setDettaglioData({ descrizione: '', idFonte: selectedFonte.id });
                  setShowAddDettaglioModal(true);
                }}
              >
                <PlusIcon className="h-5 w-5 mr-2" />
                Aggiungi Dettaglio
              </button>
            ) : (
              <button
                type="button"
                className="bg-gray-400 text-white px-4 py-2 rounded-md flex items-center cursor-not-allowed"
                disabled={true}
                onClick={() => setErrorMessage('Seleziona prima una fonte')}
              >
                <PlusIcon className="h-5 w-5 mr-2" />
                Aggiungi Dettaglio
              </button>
            )}
          </div>
          
          {!selectedFonte ? (
            <div className="text-center py-4 text-gray-500">Seleziona una fonte per visualizzare i dettagli</div>
          ) : loading && dettagliProvenienza.length === 0 ? (
            <div className="text-center py-4">Caricamento...</div>
          ) : dettagliProvenienza.length === 0 ? (
            <div className="text-center py-4 text-gray-500">Nessun dettaglio presente per questa fonte</div>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Descrizione</th>
                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Azioni</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {dettagliProvenienza.map((dettaglio) => (
                    <tr key={dettaglio.id}>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {dettaglio.descrizione}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                        <button
                          className="text-indigo-600 hover:text-indigo-900 mr-3"
                          onClick={() => {
                            setDettaglioData(dettaglio);
                            setShowEditDettaglioModal(true);
                          }}
                        >
                          <PencilIcon className="h-5 w-5" />
                        </button>
                        <button
                          className="text-red-600 hover:text-red-900"
                          onClick={() => deleteDettaglio(dettaglio.id)}
                        >
                          <TrashIcon className="h-5 w-5" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
      
      {/* Modal Aggiungi Fonte */}
      {showAddFonteModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md">
            <h3 className="text-lg font-semibold mb-4">Aggiungi Fonte</h3>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Descrizione <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                className="w-full p-2 border border-gray-300 rounded-md"
                value={fonteData.descrizione}
                onChange={(e) => setFonteData({ ...fonteData, descrizione: e.target.value })}
              />
            </div>
            <div className="flex justify-end space-x-2">
              <button
                className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400"
                onClick={() => setShowAddFonteModal(false)}
              >
                Annulla
              </button>
              <button
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                onClick={addFonte}
                disabled={loading}
              >
                {loading ? 'Salvataggio...' : 'Salva'}
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* Modal Modifica Fonte */}
      {showEditFonteModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md">
            <h3 className="text-lg font-semibold mb-4">Modifica Fonte</h3>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Descrizione <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                className="w-full p-2 border border-gray-300 rounded-md"
                value={fonteData.descrizione}
                onChange={(e) => setFonteData({ ...fonteData, descrizione: e.target.value })}
              />
            </div>
            <div className="flex justify-end space-x-2">
              <button
                className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400"
                onClick={() => setShowEditFonteModal(false)}
              >
                Annulla
              </button>
              <button
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                onClick={updateFonte}
                disabled={loading}
              >
                {loading ? 'Salvataggio...' : 'Salva'}
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* Modal Aggiungi Dettaglio */}
      {showAddDettaglioModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md">
            <h3 className="text-lg font-semibold mb-4">Aggiungi Dettaglio</h3>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Fonte
              </label>
              <input
                type="text"
                className="w-full p-2 border border-gray-300 rounded-md bg-gray-100"
                value={selectedFonte?.descrizione || ''}
                disabled
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Descrizione <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                className="w-full p-2 border border-gray-300 rounded-md"
                value={dettaglioData.descrizione}
                onChange={(e) => setDettaglioData({ ...dettaglioData, descrizione: e.target.value })}
              />
            </div>
            <div className="flex justify-end space-x-2">
              <button
                className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400"
                onClick={() => setShowAddDettaglioModal(false)}
              >
                Annulla
              </button>
              <button
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                onClick={addDettaglio}
                disabled={loading}
              >
                {loading ? 'Salvataggio...' : 'Salva'}
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* Modal Modifica Dettaglio */}
      {showEditDettaglioModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md">
            <h3 className="text-lg font-semibold mb-4">Modifica Dettaglio</h3>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Fonte
              </label>
              <input
                type="text"
                className="w-full p-2 border border-gray-300 rounded-md bg-gray-100"
                value={selectedFonte?.descrizione || ''}
                disabled
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Descrizione <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                className="w-full p-2 border border-gray-300 rounded-md"
                value={dettaglioData.descrizione}
                onChange={(e) => setDettaglioData({ ...dettaglioData, descrizione: e.target.value })}
              />
            </div>
            <div className="flex justify-end space-x-2">
              <button
                className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400"
                onClick={() => setShowEditDettaglioModal(false)}
              >
                Annulla
              </button>
              <button
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                onClick={updateDettaglio}
                disabled={loading}
              >
                {loading ? 'Salvataggio...' : 'Salva'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GestioneFontiProvenienza; 